import axios from "axios";
import { todayIso } from "../../components/DesignCalendar/designCalendarModel";

const API_URL = process.env.REACT_APP_API_URL;

export const DESIGN_CALENDAR_EVENT = "design-calendar-changed";

function headers() {
  return { Authorization: `Bearer ${localStorage.getItem("token")}` };
}

export function notifyDesignCalendarChanged() {
  window.dispatchEvent(new Event(DESIGN_CALENDAR_EVENT));
}

export async function fetchDesignCalendar(anio) {
  const { data } = await axios.get(`${API_URL}/api/design-calendar`, {
    headers: headers(),
    params: { anio },
  });
  return data;
}

export async function fetchDesignCalendarAvisos(hoy = todayIso()) {
  const { data } = await axios.get(`${API_URL}/api/design-calendar/avisos`, {
    headers: headers(),
    params: { hoy },
  });
  return data || { items: [], count: 0 };
}

export async function markDesignCalendarAvisoVisto(kind, id) {
  const { data } = await axios.post(
    `${API_URL}/api/design-calendar/avisos/visto`,
    { kind, id },
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function createDesignCalendarNota(body) {
  const { data } = await axios.post(
    `${API_URL}/api/design-calendar/notas`,
    body,
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function updateDesignCalendarNota(id, body) {
  const { data } = await axios.patch(
    `${API_URL}/api/design-calendar/notas/${id}`,
    body,
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function deleteDesignCalendarNota(id) {
  const { data } = await axios.delete(
    `${API_URL}/api/design-calendar/notas/${id}`,
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function createDesignCalendarAccion(body) {
  const { data } = await axios.post(
    `${API_URL}/api/design-calendar/acciones`,
    body,
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function updateDesignCalendarAccion(id, body) {
  const { data } = await axios.patch(
    `${API_URL}/api/design-calendar/acciones/${id}`,
    body,
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function deleteDesignCalendarAccion(id) {
  const { data } = await axios.delete(
    `${API_URL}/api/design-calendar/acciones/${id}`,
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function copyDesignCalendarYear(fromAnio, toAnio) {
  const { data } = await axios.post(
    `${API_URL}/api/design-calendar/copy-year`,
    { fromAnio, toAnio },
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function deleteDesignCalendarYear(anio, confirm, confirmAnio) {
  const { data } = await axios.post(
    `${API_URL}/api/design-calendar/delete-year`,
    { anio, confirm, confirmAnio },
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}

export async function fetchDesignCalendarClientes() {
  const { data } = await axios.get(`${API_URL}/api/design-calendar/clientes`, {
    headers: headers(),
  });
  return data;
}

export async function updateDesignCalendarCliente(id, body) {
  const { data } = await axios.patch(
    `${API_URL}/api/design-calendar/clientes/${id}`,
    body,
    { headers: headers() },
  );
  notifyDesignCalendarChanged();
  return data;
}
